/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/DefaultExperimentWorkflowFolder
 * @desc Set the default_experiment_workflow_folder for this group
 */

import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { GroupFormShowEditDefaultExperimentWorkflowFolderProps } from './types';

export const GroupFormShowEditDefaultExperimentWorkflowFolder: React.FC<
  GroupFormShowEditDefaultExperimentWorkflowFolderProps
> = ({ group }) => (
  <FormShowEditSearchSelect
    placeholder={`Specify default ${Folder.getHumanReadableEntityName(
      false,
      false,
    )}`}
    childEntityName={Folder.entityName}
    parentEntity={group}
    searchSelectProps={{
      params: { group_id: group.id, type: 'experiment_workflow' },
      creatable: false,
      isClearable: true,
    }}
    childKeyName="default_experiment_workflow_folder"
    childIdAttr="guid"
  >
    <div>
      {group.default_experiment_workflow_folder
        ? group.default_experiment_workflow_folder.name
        : 'No default experiment collection set'}
    </div>
  </FormShowEditSearchSelect>
);
